import { useEffect } from "react";
import { IoEyeSharp } from 'react-icons/io5'
import { Button } from "antd";
import { Link } from 'react-router-dom'
import { AiFillSetting } from 'react-icons/ai' 
import styled from "styled-components";
import TableControl from "../../component/table/TableControl";

const Dot = styled.div`
    height: 16px;
    width: 16px;
    margin-right: 3px;
    background-color: ${ props => props.color ? props.color :"#bbb"};
    border-radius: 50%;
    display: inline-block;
`

export default function Index(props) {
  
  useEffect(() => {

  }, []);

  const getStationStatus = (code, msg) =>{
    if(code == 1){
      return <div style={{display: 'flex', alignItems: 'center'}}><Dot color={'#25EF13'} title={msg}/>{msg}</div>
    }else if(code == 2){
      return <div style={{display: 'flex', alignItems: 'center'}}><Dot color={'#FFD02B'} title={msg}/>{msg}</div>
    }else if(code == 3){
      return <div style={{display: 'flex', alignItems: 'center'}}><Dot color={'#800020'} title={msg}/>{msg}</div>
    }else{
      return <div style={{display: 'flex', alignItems: 'center'}}><Dot color={'#333333'} title={msg}/>{msg}</div>
    }
  }

  const column = [
    { title: "สถานี", dataIndex: "station_name", align: "left", className:"cn allow-search", sorter: (a, b) => a.station_name.localeCompare(b.station_name), },
    { title: "จังหวัด", dataIndex: "province_name", align: "left", className:"cn allow-search", sorter: (a, b) => a.province_name.localeCompare(b.province_name), },
    { title: "เซนเซอร์", dataIndex: "sensor_disp_name", align: "left", className:"cn allow-search", sorter: (a, b) => a.sensor_disp_name.localeCompare(b.sensor_disp_name), },
    { title: "พารามิเตอร์", dataIndex: "parameter_disp_name", align: "center", className:"cn allow-search", onFilter: (value, record) => record.parameter_disp_name.indexOf(value) === 0, sorter: (a, b) => a.parameter_disp_name.localeCompare(b.parameter_disp_name) },
    { title: "เวลารับข้อมูลล่าสุด", dataIndex: "data_datetime", align: "center", className:"cn allow-search",  sorter: (a, b) => new Date(a.data_datetime) - new Date(b.data_datetime) },
    { title: "ข้อมูลล่าสุด", dataIndex: "proc_data", align: "center", className:"cn allow-search", sorter: (a, b) => a.proc_data - b.proc_data, },
    { title: "สถานะ", dataIndex: "status", align: "center", className:"cn", sorter: (a, b) => a.connection_status - b.connection_status,
      render: (_, record) => (
        <>
          {getStationStatus(record.connection_status, record.disp_connection)}
        </>
      ),
    },
    { title: <AiFillSetting/>, dataIndex: "graph", align: "center", width: 40, className:"cell-graph", 
    render: (_, record) => (
      <>
         <Link to={'/stations/'+record.station_id}><Button><IoEyeSharp style={{color: "#006994"}}/></Button></Link>
      </>
    ),
    },
  ];

  return (
    <TableControl
      className={
        "table-list-data" +
        (props.className ? props.className : "")
      }
      rowKey={'data_id'}
      data={props.data}
      filterData={props.filterData} 
      fncSetFilterData={props.fncSetFilterData}
      columns={column}
      dataSet={1}
    />
  );
}
